    angular.module('qkr').factory('immutableUtilityService', ImmutableUtilityService);

    /* eslint fp/no-mutation: 0 */
    ImmutableUtilityService.$inject = ['$http', 'appConfig', '$q', 'utils'];

    function ImmutableUtilityService() {
        return {

            immutableSplice(arr, start, deleteCount, ...items) {
                return [...arr.slice(0, start), ...items, ...arr.slice(start + deleteCount)];
            }
        };
    }



// WEBPACK FOOTER //
// ./src/services/immutableUtility.service.js